module.exports = __webpack_public_path__ + "img/exhibition.efacae09.png";